import React from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";
import { useDispatch, useSelector } from "react-redux";
import { deleteParagraphAsync } from "../../../redux/paragraph";
import { getFullTranscriptionByIdAsync } from "../../../redux/transcription";
import { pushUndo, buildUndoEntry } from "../../../redux/undo";
import { GetParagraphById } from "../../../services/paragraphs";

export default function DeleteParagraphConfirmModal({ paragraphId, isOpen, onClose, sessionId }) {
  const dispatch = useDispatch();
//   const loading = useSelector((state) => state.paragraphs.loading);

  const handleDelete = async () => {
    // Read the row first — the modal only receives an id, and undo needs the
    // whole paragraph to recreate it.
    let before = null;
    try {
      before = await GetParagraphById(paragraphId);
    } catch (e) {
      before = null;
    }

    await dispatch(deleteParagraphAsync(paragraphId));

    if (before) {
      dispatch(pushUndo(buildUndoEntry({
        type: "delete",
        label: "Absatz löschen",
        sessionId,
        before: [before],
        after: [],
      })));
    }

    await dispatch(getFullTranscriptionByIdAsync(sessionId))
    onClose();
    // Optional: window.location.reload(); or dispatch(getAllParagraphsAsync());
  };

  return (
    <Modal isOpen={isOpen} onOpenChange={onClose} size="md" placement="center">
      <ModalContent>
        {(modalClose) => (
          <>
            <ModalHeader>Absatz löschen</ModalHeader>
            <ModalBody>
              <p>Soll dieser Absatz wirklich gelöscht werden? Der Schritt kann mit "Rückgängig" zurückgenommen werden.</p>
            </ModalBody>
            <ModalFooter>
              <Button variant="bordered" color="default" radius="full" onPress={onClose}>
                Abbrechen
              </Button>
              <Button
                color="danger"
                onPress={handleDelete}
                
              >
                Löschen
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
